import { styled } from '@linaria/react';
import { fonts, semantic, space } from '../../theme/tokens';

export const Message = styled.p`
  margin: 0;
  padding-bottom: ${space['space-400']};
  font-family: ${fonts.body};
  font-size: ${fonts.size.base};
  font-weight: ${fonts.weight.normal};
  color: ${semantic.text.secondary};
`;

export const Actions = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${space['space-200']};
  padding: ${space['space-400']} ${space['space-600']};
`;
